import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { requestsService } from '../service/request.service';

export const useRequests = (params: { streetId?: number }) => {
  return useInfiniteQuery({
    queryKey: ['requests', params.streetId], 
    queryFn: ({ pageParam = 0 }) => 
      requestsService.findAll({ offset: pageParam, streetId: params.streetId }),
    
    getNextPageParam: (lastPage) => {
      const nextOffset = lastPage.offset + lastPage.limit;
      return nextOffset < lastPage.total ? nextOffset : undefined;
    },
    initialPageParam: 0,
  });
};

export const useRequestByNumber = (requestNum?: number) => {
  return useQuery({
    queryKey: ['requests', 'by-number', requestNum],
    queryFn: () => requestsService.getRequestByNumber(requestNum!),
    enabled: !!requestNum,
    staleTime: 5 * 60 * 1000,
  })
}

export const useMapRequests = (problemId?: number, period?: string) => {
  return useQuery({
    queryKey: ['requests', 'map', 'points', { problemId, period }],
    queryFn: () => requestsService.getMapRequests(problemId, period),
    
    staleTime: 10 * 60 * 1000,
  })
}

export const useRequestsCounters = (period?: string) => {
  return useQuery({
    queryKey: ['requests', 'counters', period],
    queryFn: () => requestsService.getRequestsCounters(period),
    staleTime: 10 * 60 * 1000,
  })
}

export const useRequestsByHouseId = (
  houseId?: number,
  problemId?: number,
  period?: string,
) => {
  return useInfiniteQuery({
    queryKey: ['requests', 'by-house', houseId, problemId, period],
    queryFn: ({ pageParam = 0 }) =>
      requestsService.getRequestsByHouseId(
        houseId!,
        problemId,
        period,
        5,
        pageParam,
      ),
    enabled: !!houseId,
    staleTime: 5 * 60 * 1000,
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) => {
      if (!lastPage.hasMore) return undefined
      return allPages.reduce((sum, page) => sum + page.data.length, 0)
    },
  })
}

export interface RequestProblem {
  id: number
  parentId: number | null
  nameUa: string
  clientGroup: number | null
}
 
export const useRequestProblems = () => {
  return useQuery({
    queryKey: ['requests', 'problems'],
    queryFn: () => requestsService.getProblems(),
    staleTime: 30 * 60 * 1000,
  })
}
 

 